export default __webpack_public_path__ + "static/media/ara.03f32ab7.png";